import React from 'react';

const NoProducts = () => (
  <p className="u-text-center u-mb-auto">
    There are no products added, please add products first.
  </p>
);

export default NoProducts;
